import { reset, SubmissionError } from 'redux-form';
import forEach from 'lodash/forEach';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import { actions as parentActions } from '../../index';

const defaultInitialState = {
	isShow: false,
	initialValues: null
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const TOGGLE_FORM = `${namespace}/${stateNodeName}-toggle-form`;
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;
	const FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-error`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		configFormSubmit: formData => (dispatch, getState) => {
			let config = null;
			try {
				config = JSON.parse(formData.wm_config);
			} catch (e) {
				config = null;
			}
			const data = {
				wm_config: config
			};

			const request = http({
				url: endpoints.WM.CONFIG,
				method: 'put',
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR],
				data
			});

			return request(dispatch).then(action => {
				if (action.type === FORM_SUBMIT_SUCCESS) {
					dispatch(parentActions.fetchData());
				}

				if (action.type === FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
					const validationsErrors = {};
					const responseErrors = action.payload.response.data;

					forEach(responseErrors, value => {
						const key = value.dataPath.slice(1);
						validationsErrors[key] = value.message;
					});

					throw new SubmissionError(validationsErrors);
				}
			});
		},

		toggleConfigForm: () => dispatch => {
			dispatch(reset(formName));
			dispatch({ type: TOGGLE_FORM });
		}
	};

	// reducers
	const reducers = {
		[TOGGLE_FORM]: (state, action) => ({
			...state,
			configForm: {
				...initialState,
				isShow: !state.configForm.isShow
			}
		}),

		[FORM_SUBMIT_SUCCESS]: state => ({
			...state,
			configForm: {
				...state.configForm,
				isShow: false
			}
		})
	};

	// selectors
	const selectors = {
		getInitialValues: state => {
			return state[`${namespace}`].configForm.initialValues;
		},
		getShouldShowConfigForm: state => state[`${namespace}`].configForm.isShow
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/wm/components/config-form/index.js